import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const getSpecialOrdersReasons = () => apiActionCreator({
  'endpoint': '/orders/dealers/special-reasons',
  'authenticated': true,
  'types': [
    ActionTypes.GET_SPECIAL_ORDERS_REASONS_REQUEST,
    ActionTypes.GET_SPECIAL_ORDERS_REASONS_SUCCESS,
    [
      ActionTypes.GET_SPECIAL_ORDERS_REASONS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const checkDealerSpecialOrderElement = (data, allowSamePart = false) => apiActionCreator({
  'endpoint': `/orders/dealers/specials${getUrlParameters({
    'partCode': data.partCode, 'dealer': data.dealer, 'agency': data.agency, 'allowOrder': allowSamePart,
  })}`,
  'authenticated': true,
  'types': [
    ActionTypes.CHECK_DEALER_SPECIAL_ORDER_ELEMENT_REQUEST,
    [
      {
        'type': ActionTypes.CHECK_DEALER_SPECIAL_ORDER_ELEMENT_SUCCESS,
        'payload': data,
      },
    ],
    [
      {
        'type': ActionTypes.CHECK_DEALER_SPECIAL_ORDER_ELEMENT_FAILED,
        'payload': data,
      },
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const createDealerSpecialOrder = (data) => apiActionCreator({
  'endpoint': '/orders/dealers/specials',
  'authenticated': true,
  'types': [
    ActionTypes.CREATE_DEALER_SPECIAL_ORDER_REQUEST,
    [
      ActionTypes.CREATE_DEALER_SPECIAL_ORDER_SUCCESS,
      (response) => MessageActions.addMessageBoxInfo(
        `Pedido especial número ${response.code} procesado satisfactoriamente`
      ),
    ],
    [
      ActionTypes.CREATE_DEALER_SPECIAL_ORDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': data,
});

export const removeElementFromSpecialOrder = (index) => ({
  'type': ActionTypes.REMOVE_ELEMENT_FROM_SPECIAL_ORDER,
  'payload': index,
});

export const restoreDealerSpecialOrder = () => ({
  'type': ActionTypes.RESTORE_DEALER_SPECIAL_ORDER,
});

export const closeDealerSpecialOrderConfirmation = () => ({
  'type': ActionTypes.CLOSE_DEALER_SPECIAL_ORDER_CONFIRMATION,
});
export const getVehicleInf = (chassis) => apiActionCreator({
  'endpoint': `/orders/vin-info/${chassis}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_VEHICLE_INF,
    [
      {
        'type': ActionTypes.FETCHED_VEHICLE_INF,
      },
    ],
    [
      {
        'type': ActionTypes.FETCHED_VEHICLE_INF_FAILED,
      },
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
